<template>
  <!-- 资讯中心 -->
  <div class="information-center" v-if="listData.length>0">
    <div class="information-center_div">
      <div class="home-title">
        <img src="@/assets/left.png" alt="" class="information-center_img">
        <div class="home-title-main">
          <p> 资讯中心</p>
          <p> 聚焦美课教育，彰显品牌影响力</p>
        </div>
        <img src="@/assets/right.png" alt="" class="information-center_img">
      </div>
    </div>
    <div style="width:1080px;margin:20px auto;">
      <ul class="information-center_tab">
        <li v-for="(item,i) in listData" :key="i" @click="toNewsDetails(item.id)">
          <img :src="item.thumb" class="slider_img">
          <div class="newsList-des-div">
            <h3 class="newsList-des-h3">{{item.title}}</h3>
            <P class="newsList-des-p"> {{item.description}}</P>
            <div class="newsList-des-note">
              <span class="newsList-des-noteDate">{{item.create_time}}</span>
              <span>阅读：{{item.look}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  // import slider components
  import {
    slider,
    slideritem
  } from 'vue-concise-slider'
  export default {
    name: 'information',
    data() {
      return {
        listData: [],
        total: 0,
        // Slider configuration [obj]
        options: {
          currentPage: 0, // 当前页码
          slidesToScroll: 1, // 每次滑动项数
          autoplay: 6000, // 自动滚动[ms]
          loop: true, // 循环滚动
          renderPagination: (h, index) => {
            return h('div', {
              class: 'swiper-pagination-bullet'
            }, [index])
          }
        }
      }
    },
    components: {
      slider,
      slideritem
    },
    created() {
      this.getInfo()
    },
    methods: {
      getInfo() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/article/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            limit: 4
          }
        }).then(res => {
          this.listData = res.data.data.data
          this.total = res.data.data.total
        }).catch(err => {
          console.log(err)
        })
      },
      toNewsDetails(id) {
        this.$router.push({
          path: "/NewsDetails",
          query: {
            id: id
          }
        })
      }
    },
  }
</script>
<style scoped>
  /********** 资讯中心 **********/
  .information-center {
    background-color: rgb(255, 255, 255);
    width: 100%;
    height: auto;
    margin: 10px auto 65px;
  }

  .slider_img {
    width: 200px;
    height: 130px;
  }

  .information-center_tab {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top:60px;
  }

  .information-center_tab li {
    display: flex;
    height: 130px;
    margin-bottom: 50px;
    cursor: pointer;
  }

  .information-center_tab li:nth-child(2),
  .information-center_tab li:nth-child(4) {
    margin-left: 12%;
  }

  .newsList-des-div {
    width: 250px;
    color: #000;
    font-size: 24px;
    padding-left: 15px;
    /* border:1px solid #8c8c8c; */
    background-color: #f6f8fa;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
  }

  .newsList-des-h3 {
    font-size: 20px;
    display: inline-block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: top;
    margin-top: 10px;
    font-weight: 100;
    text-align: left;
  }

  .newsList-des-p {
    font-size: 14px;
    margin: 8px 0 32px;
    color: #525a67;
    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
  }

  .newsList-des-note {
    height: 20px;
    text-align:left;
  }

  .newsList-des-note span {
    display: inline-block;
    font-size: 12px;
    line-height: 20px;
    color: #87959f;
    vertical-align: top;
  }

  .newsList-des-note .newsList-des-noteTags {
    color: #fff;
    min-width: 60px;
    height: 20px;
    padding: 0 4px;
    text-align: center;
    background-color: #73b2fc;
    border-radius: 2px;
    margin-left: -30px;
  }

  .newsList-des-note .newsList-des-noteDate {
    margin-right: 6px;

  }
</style>



// WEBPACK FOOTER //
// src/components/view/Homes/information.vue